var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 82,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b4d0b6",
    fillOpacity: 0.3,
    d: "M0 82V57.637Q0 47.26 4.084 36.432a92.7 92.7 0 0 1 10.777-20.415Q21.555 6.43 29.382 0L50.71 12.52a111.2 111.2 0 0 0-10.437 20.754q-3.97 10.827-3.97 24.137V82zm57.29 0V57.637q0-10.377 4.084-21.205A92.7 92.7 0 0 1 72.15 16.017Q78.845 6.43 86.672 0L108 12.52a111.3 111.3 0 0 0-10.437 20.754q-3.97 10.827-3.97 24.137V82z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginQuote);
export default __webpack_public_path__ + "static/media/login-quote.631e18ffa0e2218c75d56020d08d0bc5.svg";
export { ForwardRef as ReactComponent };